import {
  featureTogglesRoutePerm,
  homeRoutePerm,
} from 'components/Routes/routePermissions';
import { INavItem } from './types/navItem';

export const navItems: INavItem[] = [
  {
    label: 'Home',
    path: '/home',
    icon: 'ki-home',
    group: 'main',
    permissions: homeRoutePerm,
  },
  {
    label: 'Feature Toggles',
    path: '/feature-toggles',
    icon: 'ki-flag',
    group: 'main',
    permissions: featureTogglesRoutePerm,
  },
  {
    label: 'Progressive Delivery',
    path: '/progressive-delivery',
    icon: 'ki-rocketship',
    group: 'main',
    permissions: featureTogglesRoutePerm,
  },
];
